<template>
    <div data-view="strat.investor_deck.v12019" style="height: 100%; width: 100%">
        <v-overlay dark :value="authorizedOverlay" opacity="0.98" z-index="200">
           <v-layout fill-height justify-center align-center>
               <v-window v-model="authorization">
                   <v-card min-width="450" min-height="400">
                        <v-window-item>
                            <v-card flat class="pa-6" color="" width="450" height="450">
                                <v-card-title class="pb-0 t24">Uh oh!</v-card-title>
                                <v-card-text class="pt-0 t16 ">There seems to be an issue with your Access Code</v-card-text>
                                <v-card-text class="pb-12" style="height: 200px">
                                    <div class="t16">Should you continue to have issues contact your <strong>Strategery</strong> or <strong>Dolo Labs</strong> representative and they can provide you a new access code</div>
                                    <div class="amber--text mt-4">FYI: Access Codes expire after 24 hours</div>
                                </v-card-text>
                                <v-card-actions class="pt-12">
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="killDeck()">Cancel</v-btn>
                                    <v-btn text color="accent" @click="backtoCode()">Try again</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-window-item>
                        <v-window-item>
                            <v-card flat class="pa-6" color="" width="450" height="450">
                                <v-card-title class="pb-0">Enter your code to continue</v-card-title>
                                <v-card-text class="pt-0">
                                    <span class="">Before you can view the content you will need to enter the access code provided to you by a <strong>Strategery</strong> or <strong>Dolo Labs</strong> representative</span>
                                </v-card-text>
                                <v-card-text>
                                    <v-text-field
                                        label="Enter Access Code"
                                        outlined
                                        v-model="inputCode"
                                    ></v-text-field>
                                </v-card-text>
                                <v-card-text class="pt-0 pb-12 text-right">
                                    <div class="">Don't have an access code?</div>
                                    <div class="amber--text">Request Access Here</div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="killDeck()">cancel</v-btn>
                                    <v-btn text color="accent" @click="authorize()">Next</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-window-item>
                        <v-window-item>
                            <v-card height="700" width="700">
                                <v-card-title>
                                    Confidentiality & Non-disclosure Agreement
                                </v-card-title>
                                <v-card-text style="height: 500px; overflow-y: scroll; overflow-x: hidden; padding-bottom: 50px">
                                    <nda :ndaInfo="ndaInfo"/>
                                </v-card-text>
                            </v-card>
                            <v-footer absolute class="pa-4">
                                <v-layout row  mb-4 px-8 align-center>
                                    <v-flex xs1>
                                        <v-btn fab small outlined :color="nda ? 'light-green' : 'secondary'" @click="acceptNDA()">
                                            <v-icon v-if="nda" color="light-green">check</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs11>
                                        <span class="t12">By selecting this and the get started button, I understand and agree to the "Confidential and Non-Disclosure Agreement" from above.</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                    <v-btn text @click="killDeck()">Cancel</v-btn>
                                    <v-btn text :disabled="!nda" color="accent" @click="ndaCompleted()">Get Started</v-btn>
                                </v-layout>
                            </v-footer>
                        </v-window-item>
                   </v-card>
                </v-window>
            </v-layout>
        </v-overlay>
        <v-layout fill-height class="primary" justify-end align-center>
            <div class="id-primary mt-n4" style="">
                <v-layout justify-center class="fw">
                    <div class="id-title t24 py-12 text-uppercase" :class="started && activeWindow != 1 ? 'grey--text' : 'white--text'">
                        <span class="font-weight-black">Investor</span>
                        <span class="font-weight-light">deck</span>
                    </div>
                </v-layout>
                <v-layout justify-center mt-8>
                    <v-card flat :color="started && activeWindow != 1 ? 'grey' : 'white'" :height="started? 450 : 400" width="1" class="id-line mt-4 mb-2"></v-card>
                </v-layout>
                <v-layout justify-center mr-8>
                    <v-list rounded style="background-color: transparent !important">
                        <v-list-item-group color="primary">
                            <v-list-item
                                v-for="(m, i) in deck2Menu"
                                :key="i"
                                @click="openWindow(i)"
                                class="py-0 mb-0"
                            >
                            <v-list-item-content class="text-right py-0 mb-0">
                                <v-list-item-title v-text="m.title" class="id-item-title py-0" :class="started && activeWindow == i ? 't16 amber--text' : started && activeWindow != 1 ? 't10 grey--text' : 't10 white--text'"></v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-layout>
            </div>
            <div style="position: fixed; bottom: 100px; left: 50px; z-index: 10">
                <v-btn icon :color="started && activeWindow != 1 ? 'grey' : 'white'" @click="killDeck()">
                    <v-icon size="32">close</v-icon>
                </v-btn>
            </div>
            <v-card flat class="max" color="primary darken-1" ripple @click="getStarted()">
                <v-layout fill-height align-center px-12>
                    <v-card flat color="transparent" style="z-index: 1">
                        <v-card-text class="t40 font-weight-black white--text" :class="started ? 'd-none' : ''" style="">
                            Strategery
                        </v-card-text>
                        <v-card-text class="pt-3" :class="started ? 'd-none' : ''">
                            <v-card height="3" width="40" color="amber" flat></v-card>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-card>
            <div class="strat-window" :class="coWindow? 'open' : ''">
                <div class=" strat-panel-third">
                    <v-card flat tile class="max" color="white">
                        <company-highlights @last="last" @next="next" @nextSection="nextSection()" @lastSection="lastSection()" @setWindow="setWindow" :reset="reset"/>
                    </v-card>
                </div>
                <div class="white strat-panel-full two">
                    <company-overview :co="co" :coLength="coLength"/>
                </div>
            </div>
            <div class="strat-window" :class="pWindow? 'open' : ''">
                <div class="accent strat-panel-full"></div>
            </div>
            <div class="strat-window" :class="moWindow? 'open' : ''">
                <div class="primary darken-3 strat-panel-third">
                    <v-card tile outlined class="max" color="transparent">
                        <v-card-title>Something</v-card-title>
                        <v-btn @click="coWindow = false">Close me</v-btn>
                    </v-card>
                </div>
                <div class="white strat-panel-full two"></div>
            </div>
            <div class="strat-window" :class="boWindow? 'open' : ''">
                <div class="primary darken-3 strat-panel-third">
                    <v-card tile outlined class="max" color="transparent">
                        <v-card-title>Something</v-card-title>
                        <v-btn @click="coWindow = false">Close me</v-btn>
                    </v-card>
                </div>
                <div class="white strat-panel-full two"></div>
            </div>
            <div class="t10" :class="started && activeWindow != 1 ? 'grey--text' : 'white--text'" style="position: fixed; bottom: 20px; left: 50px; z-index: 10">
                Confidential and Proprietary. © Copyright Dolo Labs LLC. All rights reserved. {{co}}
            </div>
        </v-layout>
    </div>
</template>

<script>
import nda from '../components/nda_doc'
//import companyOverview from '../components/ir_deck/company_overview'
//import idGetStarted from './investor_deck/id-get-started'
import companyOverview from './investor_deck/company-overview/company-overview'
import companyHighlights from './investor_deck/company-overview/company-highlights'
//import idStarted from './investor_deck/id-started'

export default {
    components: {
        nda,
        //idGetStarted,
        companyOverview,
        companyHighlights
    },
    props: {},
    data: () => {
        return {
            authorized: false,
            nda: false,
            ndaError: false,
            authorizedOverlay: true,
            authorization: 1,
            inputCode: '',
            authCode: '1234567',
            curDate: '',
            ndaInfo: {
                name: 'Ryan Wall',
                address: '22323 Awesome Lane, Awesome Town, PA 12345',
                reason: 'For the reasons of money and world domination'
            },
            deck2Menu: [
                {
                    title: 'Company Overview',
                    deck2val: 0,
                },
                {
                    title: 'Product Universe',
                    deck2val: 1,
                },
                {
                    title: 'Market Overview',
                    deck2val: 2,
                },
                {
                    title: 'Business Overview',
                    deck2val: 3,
                }
            ],
            started: false,
            activeWindow: '',
            coWindow: false,
            co: '',
            coLength: 3,
            pWindow: false,
            p: 0,
            pLength: 10,
            moWindow: false,
            mo: 0,
            moLength: 10,
            boWindow: false,
            bo: 0,
            boLength: 10,
            reset: false,
        }
    },
    mounted() {
    
    },
    beforeDestroy: function () {
    },
    methods: {
        backtoCode(){
            this.authorization = 1
        },
        authorize(){
            if(this.inputCode == this.authCode) {
                this.authorized = true
                this.authorization = 2
            } else {
                this.authorization = 0
            }
        },
        acceptNDA(){
            this.nda = true
        },
        ndaCompleted(){
            if(this.nda == true) {
                this.authorizedOverlay = false
            } else {
                this.ndaError = true
            }
        },
        killDeck(){
            this.$emit('killDeck')
            this.inputCode = ''
            this.nda = false
            this.authorized = false
            this.authorization = 1
            this.started = false
            this.activeWindow = ''
            this.coWindow = false
            this.co = 0
            this.pWindow = false
            this.p = 0
            this.moWindow = false
            this.mo = 0
            this.boWindow = false
            this.bo = 0
            this.reset = true
        },
        getStarted(){
            this.started = true
            this.coWindow = true
            this.activeWindow = 0
            this.co = 0
        },
        toStart(){
            this.started = false
            this.activeWindow = ''
            this.coWindow = false
            this.co = 0
            this.pWindow = false
            this.p = 0
            this.moWindow = false
            this.mo = 0
            this.boWindow = false
            this.bo = 0
        },
        openWindow(w){
            if(w == 0) {
                this.activeWindow = 0
                this.coWindow = true
                this.pWindow = false
                this.moWindow = false
                this.boWindow = false
            } else if(w == 1){
                this.activeWindow = 1
                this.coWindow = false
                this.pWindow = true
                this.moWindow = false
                this.boWindow = false
            } else if(w == 2){
                this.activeWindow = 2
                this.coWindow = false
                this.pWindow = false
                this.moWindow = true
                this.boWindow = false
            } else if(w == 3){
                this.activeWindow = 3
                this.coWindow = false
                this.pWindow = false
                this.moWindow = false
                this.boWindow = true
            }
        },
        last(a, b){
            if(b == 'co') {
                this.co = a
                //eslint-disable-next-line
                console.log('investor_deck.methods.last -- recieving ... num: '+a+' type: '+b)
            }else if(b == 'po') {
                this.po = a
            }else if(b == 'p') {
                this.p = a
            }else if(b == 'mo') {
                this.mo = a
            }else if(b == 'bo') {
                this.bo = a
            }else {
                //eslint-disable-next-line
                console.log('investor_deck.methods.last -- recieving ... num: '+a+' type: '+b)
            }
        },
        lastSection(){
            if(this.activeWindow == 0) {
                this.activeWindow = 0
                this.coWindow = true
                this.pWindow = false
                this.moWindow = false
                this.boWindow = false
            } else if(this.activeWindow == 1){
                this.activeWindow = 0
                this.coWindow = true
                this.pWindow = false
                this.moWindow = false
                this.boWindow = false
            } else if(this.activeWindow == 2){
                this.activeWindow = 1
                this.coWindow = false
                this.pWindow = true
                this.moWindow = false
                this.boWindow = true
            } else if(this.activeWindow == 3){
                this.activeWindow = 2
                this.coWindow = false
                this.pWindow = false
                this.moWindow = true
                this.boWindow = false
            }
        },
        next(a, b){
            if(b == 'co') {
                this.co = a
                //eslint-disable-next-line
                console.log('investor_deck.methods.last -- recieving ... num: '+a+' type: '+b)
            }else if(b == 'po') {
                this.po = a
            }else if(b == 'p') {
                this.p = a
            }else if(b == 'mo') {
                this.mo = a
            }else if(b == 'bo') {
                this.bo = a
            } else {
                //eslint-disable-next-line
                //console.log('investor_deck.methods.next -- recieving ... num: '+a+' type: '+b)
            }
        },
        nextSection(){
            if(this.activeWindow == 0) {
                this.activeWindow = 1
                this.coWindow = false
                this.pWindow = true
                this.moWindow = false
                this.boWindow = false
            } else if(this.activeWindow == 1){
                this.activeWindow = 2
                this.coWindow = false
                this.pWindow = false
                this.moWindow = true
                this.boWindow = false
            } else if(this.activeWindow == 2){
                this.activeWindow = 3
                this.coWindow = false
                this.pWindow = false
                this.moWindow = false
                this.boWindow = true
            } else if(this.activeWindow == 3){
                this.activeWindow = 3
                this.coWindow = false
                this.pWindow = false
                this.moWindow = false
                this.boWindow = true
            }
        },
        setWindow(a, b){
            if(b == 'co') {
                this.co = a
                //eslint-disable-next-line
                console.log('investor_deck.methods.last -- recieving ... num: '+a+' type: '+b)
            }else if(b == 'po') {
                this.po = a
            }else if(b == 'p') {
                this.p = a
            }else if(b == 'mo') {
                this.mo = a
            }else if(b == 'bo') {
                this.bo = a
            } else {
                //eslint-disable-next-line
                console.log('investor_deck.methods.next -- recieving ... num: '+a+' type: '+b)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .auth-overlay {
        position: fixed;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 200;
    }
    .id-primary {
        width: 70px;
        position: fixed;
        top: 80px;
        right: 4%;
        z-index: 10;

        .id-title {
            transform: rotate(90deg)
        }

        .id-line {
            transition: all .5s
        }

        .id-item-title {
            transition: all .5s
        }
    }

    .strat-window {
        .strat-panel-third {
            position: fixed;
            width: 20%;
            height: 100%;
            left: -32%;
            transition: all .24s;
            top: 0;
            z-index: 0;
            /* border-right: 1px solid rgba(0,0,0,.12); */
            padding: 0;
        }

        .strat-panel-full {
            position: fixed;
            width: 100%;
            height: 100%;
            left: -101%;
            transition: all .24s;
            top: 0;
            z-index: 0;
        }

        &.open {
            .strat-panel-third {
                left: 0;
                transition: all .34s;
                z-index: 4;
            }

            .strat-panel-full {
                left: 0;
                transition: all .64s;
                z-index: 3;

                &.two {
                    transition: all .44s;
                    transition-delay: .34s;
                    padding: 0 20%;
                }
            }
            
        }
    }

    .deck-section-footer {
        position: fixed;
        bottom: -74px;
        left: 10%;
        width: 80%;
        min-height: 64px;
        transition: all .15s;
        max-width: 100%;
        padding: 0 15.2%;

        &.active {
            bottom: 20px;

            &.two {
                -webkit-animation: animation 1500ms linear both;
                animation: animation 1500ms linear both;
                bottom: 0
            }
        }

        .deck-sub-menu-btn{
            transition: all .25s;
            width: 25%;
            height: 100%;

            .active-border{
                width: 0;
                transition: all .34s
            }

            &.active {
                .active-border{
                    width: 40px;
                }
            }
        }

    }

    .window-title {
        position: fixed;
        top: 20px;
        left: 130px;
        z-index: 7;

        .title {
            margin-top: 50px;
            opacity: 0;
            transition: all .34s;

            &.active {
                margin-top: 0;
                opacity: 1;
            }
        }
    }

    /* Generated with Bounce.js. Edit at http://bouncejs.com#%7Bs%3A%5B%7BT%3A%22c%22%2Ce%3A%22b%22%2Cd%3A1000%2CD%3A0%2Cf%3A%7Bx%3A1%2Cy%3A1%7D%2Ct%3A%7Bx%3A2%2Cy%3A1%7D%2Cs%3A1%2Cb%3A4%7D%2C%7BT%3A%22c%22%2Ce%3A%22b%22%2Cd%3A1000%2CD%3A0%2Cf%3A%7Bx%3A1%2Cy%3A1%7D%2Ct%3A%7Bx%3A1%2Cy%3A2%7D%2Cs%3A1%2Cb%3A6%7D%5D%7D */

    @-webkit-keyframes animation { 
        0% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        3.4% { -webkit-transform: matrix3d(1.316, 0, 0, 0, 0, 1.407, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.316, 0, 0, 0, 0, 1.407, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        4.7% { -webkit-transform: matrix3d(1.45, 0, 0, 0, 0, 1.599, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.45, 0, 0, 0, 0, 1.599, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        6.81% { -webkit-transform: matrix3d(1.659, 0, 0, 0, 0, 1.893, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.659, 0, 0, 0, 0, 1.893, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        9.41% { -webkit-transform: matrix3d(1.883, 0, 0, 0, 0, 2.168, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.883, 0, 0, 0, 0, 2.168, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        10.21% { -webkit-transform: matrix3d(1.942, 0, 0, 0, 0, 2.226, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.942, 0, 0, 0, 0, 2.226, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        13.61% { -webkit-transform: matrix3d(2.123, 0, 0, 0, 0, 2.332, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.123, 0, 0, 0, 0, 2.332, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        14.11% { -webkit-transform: matrix3d(2.141, 0, 0, 0, 0, 2.331, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.141, 0, 0, 0, 0, 2.331, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        17.52% { -webkit-transform: matrix3d(2.208, 0, 0, 0, 0, 2.239, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.208, 0, 0, 0, 0, 2.239, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        18.72% { -webkit-transform: matrix3d(2.212, 0, 0, 0, 0, 2.187, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.212, 0, 0, 0, 0, 2.187, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        21.32% { -webkit-transform: matrix3d(2.196, 0, 0, 0, 0, 2.069, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.196, 0, 0, 0, 0, 2.069, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        24.32% { -webkit-transform: matrix3d(2.151, 0, 0, 0, 0, 1.96, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.151, 0, 0, 0, 0, 1.96, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        25.23% { -webkit-transform: matrix3d(2.134, 0, 0, 0, 0, 1.938, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.134, 0, 0, 0, 0, 1.938, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        29.03% { -webkit-transform: matrix3d(2.063, 0, 0, 0, 0, 1.897, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.063, 0, 0, 0, 0, 1.897, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        29.93% { -webkit-transform: matrix3d(2.048, 0, 0, 0, 0, 1.899, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.048, 0, 0, 0, 0, 1.899, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        35.54% { -webkit-transform: matrix3d(1.979, 0, 0, 0, 0, 1.962, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.979, 0, 0, 0, 0, 1.962, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        36.74% { -webkit-transform: matrix3d(1.972, 0, 0, 0, 0, 1.979, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.972, 0, 0, 0, 0, 1.979, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        41.04% { -webkit-transform: matrix3d(1.961, 0, 0, 0, 0, 2.022, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.961, 0, 0, 0, 0, 2.022, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        44.44% { -webkit-transform: matrix3d(1.966, 0, 0, 0, 0, 2.032, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.966, 0, 0, 0, 0, 2.032, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        52.15% { -webkit-transform: matrix3d(1.991, 0, 0, 0, 0, 2.006, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.991, 0, 0, 0, 0, 2.006, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        59.86% { -webkit-transform: matrix3d(2.006, 0, 0, 0, 0, 1.99, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.006, 0, 0, 0, 0, 1.99, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        63.26% { -webkit-transform: matrix3d(2.007, 0, 0, 0, 0, 1.992, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.007, 0, 0, 0, 0, 1.992, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        75.28% { -webkit-transform: matrix3d(2.001, 0, 0, 0, 0, 2.003, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.001, 0, 0, 0, 0, 2.003, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        85.49% { -webkit-transform: matrix3d(1.999, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.999, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        90.69% { -webkit-transform: matrix3d(1.999, 0, 0, 0, 0, 1.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.999, 0, 0, 0, 0, 1.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        100% { -webkit-transform: matrix3d(2, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); } 
    }

    @keyframes animation { 
        0% { -webkit-transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        3.4% { -webkit-transform: matrix3d(1.316, 0, 0, 0, 0, 1.407, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.316, 0, 0, 0, 0, 1.407, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        4.7% { -webkit-transform: matrix3d(1.45, 0, 0, 0, 0, 1.599, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.45, 0, 0, 0, 0, 1.599, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        6.81% { -webkit-transform: matrix3d(1.659, 0, 0, 0, 0, 1.893, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.659, 0, 0, 0, 0, 1.893, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        9.41% { -webkit-transform: matrix3d(1.883, 0, 0, 0, 0, 2.168, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.883, 0, 0, 0, 0, 2.168, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        10.21% { -webkit-transform: matrix3d(1.942, 0, 0, 0, 0, 2.226, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.942, 0, 0, 0, 0, 2.226, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        13.61% { -webkit-transform: matrix3d(2.123, 0, 0, 0, 0, 2.332, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.123, 0, 0, 0, 0, 2.332, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        14.11% { -webkit-transform: matrix3d(2.141, 0, 0, 0, 0, 2.331, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.141, 0, 0, 0, 0, 2.331, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        17.52% { -webkit-transform: matrix3d(2.208, 0, 0, 0, 0, 2.239, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.208, 0, 0, 0, 0, 2.239, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        18.72% { -webkit-transform: matrix3d(2.212, 0, 0, 0, 0, 2.187, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.212, 0, 0, 0, 0, 2.187, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        21.32% { -webkit-transform: matrix3d(2.196, 0, 0, 0, 0, 2.069, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.196, 0, 0, 0, 0, 2.069, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        24.32% { -webkit-transform: matrix3d(2.151, 0, 0, 0, 0, 1.96, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.151, 0, 0, 0, 0, 1.96, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        25.23% { -webkit-transform: matrix3d(2.134, 0, 0, 0, 0, 1.938, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.134, 0, 0, 0, 0, 1.938, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        29.03% { -webkit-transform: matrix3d(2.063, 0, 0, 0, 0, 1.897, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.063, 0, 0, 0, 0, 1.897, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        29.93% { -webkit-transform: matrix3d(2.048, 0, 0, 0, 0, 1.899, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.048, 0, 0, 0, 0, 1.899, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        35.54% { -webkit-transform: matrix3d(1.979, 0, 0, 0, 0, 1.962, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.979, 0, 0, 0, 0, 1.962, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        36.74% { -webkit-transform: matrix3d(1.972, 0, 0, 0, 0, 1.979, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.972, 0, 0, 0, 0, 1.979, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        41.04% { -webkit-transform: matrix3d(1.961, 0, 0, 0, 0, 2.022, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.961, 0, 0, 0, 0, 2.022, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        44.44% { -webkit-transform: matrix3d(1.966, 0, 0, 0, 0, 2.032, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.966, 0, 0, 0, 0, 2.032, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        52.15% { -webkit-transform: matrix3d(1.991, 0, 0, 0, 0, 2.006, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.991, 0, 0, 0, 0, 2.006, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        59.86% { -webkit-transform: matrix3d(2.006, 0, 0, 0, 0, 1.99, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.006, 0, 0, 0, 0, 1.99, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        63.26% { -webkit-transform: matrix3d(2.007, 0, 0, 0, 0, 1.992, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.007, 0, 0, 0, 0, 1.992, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        75.28% { -webkit-transform: matrix3d(2.001, 0, 0, 0, 0, 2.003, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2.001, 0, 0, 0, 0, 2.003, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        85.49% { -webkit-transform: matrix3d(1.999, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.999, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        90.69% { -webkit-transform: matrix3d(1.999, 0, 0, 0, 0, 1.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(1.999, 0, 0, 0, 0, 1.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
        100% { -webkit-transform: matrix3d(2, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(2, 0, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); } 
    }
</style>